import { Component, inject, ViewChild, ElementRef, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { HistoryService } from '@cumlaude/shared-services';
import { RouterLink, RouterOutlet } from '@angular/router';
import { AdminHeaderComponent, HamburgerMenuComponent } from '@cumlaude/shared-components-menu';
import { ScrollService } from './services/scroll.service';
import { AdminMenuService } from './services/admin-menu.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrl: './app.component.scss',
	imports: [RouterOutlet, RouterLink, HamburgerMenuComponent, AdminHeaderComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit {
	// noinspection JSUnusedGlobalSymbols
	/**
	 * HistoryService moet in het hoofd component geinject worden zodat altijd de history getracked wordt tijdens het gebruiken van de applicatie.
	 * En op die manier dan de terug knoppen kunnen werken.
	 */
	historyService: HistoryService = inject(HistoryService);
	private readonly scrollService = inject(ScrollService);
	protected readonly adminMenuService = inject(AdminMenuService);

	@ViewChild('contentElement', { static: true })
	contentElement!: ElementRef<HTMLElement>;

	ngAfterViewInit() {
		this.scrollService.setContentElement(this.contentElement);
	}
}
